import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { BaseDoughnutChartPropsType } from "../../../types/component.type";

ChartJS.register(ArcElement, Tooltip, Legend);

export const BaseDoughnutChart: React.FC<BaseDoughnutChartPropsType> = ({
	title,
	labels,
	datasets,
	cutout,
	borderRadius,
	offset,
	width,
	height,
}) => {
	const data = { labels, datasets };

	const options = {
		responsive: true,
		maintainAspectRatio: false,
		plugins: {
			legend: {
				display: title === "Loan Purpose Distribution" ? true : false,
				position: "bottom" as const,
				align: "start" as const,
				labels: {
					usePointStyle: true,
					pointStyle: "circle",
					font: { family: "Inter", weight: 500, size: 10 },
				},
			},
			title: {
				display: true,
				text: title,
				align: "start" as const,
				color: "#000000",
				font: { family: "Poppins", weight: 400, size: 16 },
				padding: {
					bottom: 16,
				},
			},
		},
		datasets: {
			doughnut: {
				cutout,
				borderRadius: borderRadius,
				borderColor: "transparent",
				offset: offset,
			},
		},
	};

	return (
		<Doughnut data={data} options={options} width={width} height={height} />
	);
};
